<div class="digital-caseflow-details">
  <div class="dcf-content">
    <div class="dcf-flow">
      <div class="d-flex">
        <div class="dcfDetailText dcfDetailText-label">{{ 'digital-caseflow-flow' | translate }}</div>
        <div class="dcfDetailText"> {{ flowLog?.flowName }}</div>
      </div>
      <div class="d-flex">
        <div class="dcfDetailText dcfDetailText-label">{{ 'digital-caseflow-activity-log-status' | translate }}</div>
        <div class="dcfDetailText red" *ngIf="flowLog?.flowResult == 'FAILED'"> {{ 'status-failed-capital' | translate }}</div>
        <div class="dcfDetailText teal" *ngIf="flowLog?.flowResult != 'FAILED'"> {{ 'status-succeeded-capital' | translate }}</div>
      </div>

      <tr class="activityDetailsTable" *ngFor="let activityLog of flowLog?.activityLogs">
        <td class="activityDetailsRow">
          <div class="d-flex">
            <div *ngIf="activityLog.activityType != 'VALIDATION'" class="dcfDetailText dcfDetailText-label">{{ 'digital-caseflow-activity-log-action' | translate }}</div>
            <div *ngIf="activityLog.activityType == 'VALIDATION'" class="dcfDetailText dcfDetailText-label">{{ 'digital-caseflow-activity-log-validation' | translate }}</div>
            <div class="dcfDetailText"> {{ activityLog.activityName  }}</div>
          </div>
          <div class="d-flex">
            <div class="dcfDetailText dcfDetailText-label">{{ 'digital-caseflow-activity-log-status' | translate }}</div>
            <div class="dcfDetailText red" *ngIf="activityLog.result == 'FAILED'"> {{ getTranslatedResult(activityLog) }}</div>
            <div class="dcfDetailText orange"
                  *ngIf="activityLog.result == 'FAILED_NOT_MANDATORY'"> {{ getTranslatedResult(activityLog) }}</div>
            <div class="dcfDetailText teal" *ngIf="activityLog.result == 'SUCCESS'"> {{ getTranslatedResult(activityLog) }}</div>
          </div>
          <div *ngIf="activityLog.activityErrorLogs.length !== 0" class="d-flex">
            <div class="dcfDetailText dcfDetailText-label">{{ 'digital-caseflow-result' | translate }}</div>
            <div class="dcfDetailText"> {{ getTranslatedErrorCodes(activityLog) }}</div>
          </div>
        </td>
      </tr>
    </div>
  </div>
  <div class="dcf-footer">
    <span class="grey dcfFooterText">{{'digital-caseflow-time' | translate }}</span>
    <span class="dcfFooterText">{{ flowLog?.flowInitiationDate | momentFormat: 'DD. MMM YYYY HH:MM': 'local' }} </span>
    <span class="grey dcfFooterText">{{ 'digital-caseflow-flow-log-id' | translate }}</span>
    <span class="dcfFooterText"> {{ flowLog?.id }}</span>
  </div>
</div>
